var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M26.93 23.859l-9.051-9.051a1.002 1.002 0 010-1.415l1.414-1.414a1 1 0 011.414 0l11.314 11.314a1 1 0 010 1.414L20.707 36.021a1 1 0 01-1.414 0l-1.414-1.414a1.002 1.002 0 010-1.415l9.05-9.05a.199.199 0 000-.283z"
  })));
}
export default SvgArrowRightWhite;